import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { BulkWhatsappMessage, FreeWhatsappReceivers, WhatsappTemplate } from './whatsapp.interface';
import { WhatsappService } from './whatsapp.service';
const service = new WhatsappService();

export interface WhatsappState {
   whatsappTemplates: Array<WhatsappTemplate>;
}

const WhatsappStore: Module<WhatsappState, StoreState> = {
   namespaced: true,
   state: {
      whatsappTemplates: [],
   },
   getters: {},
   mutations: {
      SET_WHATSAPP_TEMPLATES(state, templates) {
         state.whatsappTemplates = templates;
      },
   },
   actions: {
      async allowedFreeWhatsapp(context, freeWhatsappReceivers: FreeWhatsappReceivers) {
         const response = await service.CheckFreeWhatsappReceivers(freeWhatsappReceivers);
         return response;
      },
      async sendBulk(context, candidateBulkSms: BulkWhatsappMessage) {
         return await service.sendBulk(candidateBulkSms);
      },
      async getWhatsappTemplates(context) {
         const response = await service.getWhatsappTemplates();
         context.commit('SET_WHATSAPP_TEMPLATES', response.data);
         return response;
      },
   },
};

export default WhatsappStore;
